import React, {useEffect, useState} from 'react';
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Spinner} from "reactstrap";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {getDb} from "../../util/Constants";

function EditDifficulty(props) {
    const [difficulty, setDifficulty] = useState("");
    const [passingScore, setPassingScore] = useState("");
    const [load, setLoad] = useState(false);

    useEffect(() => {
        fetchDifficulty();
    }, [])


    const fetchDifficulty = async () => {

        const docRef = doc(getDb(), "levelDifficultyScores", props?.item?.id);
        const querySnapshot = await getDoc(docRef);
        const _levelDifficulty = querySnapshot.data();
        setDifficulty(_levelDifficulty.difficulty);
        setPassingScore(_levelDifficulty.passingScore);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);
        const docRef = doc(getDb(), "levelDifficultyScores", props?.item?.id);
        let dataCapital = difficulty.charAt(0).toUpperCase() + difficulty.slice(1)
        await updateDoc(docRef, {
            difficulty: dataCapital,
            passingScore: Number(passingScore),
        });
        props.getDifficulties();
        setLoad(false);
        props.toggle();
        setDifficulty("");
        setPassingScore("");
    };


    return (
        <div>

            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Edit Difficulty</ModalHeader>
                <ModalBody style={{paddingTop: "10px"}}>
                    <Form onSubmit={handleSubmit}>
                        <div className="">

                            <FormGroup>
                                <Label for="department">
                                    Difficulty
                                </Label>
                                <Input
                                    type="text"
                                    id="department"
                                    maxLength="250"
                                    value={difficulty}
                                    disabled
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setDifficulty(e.target.value)}
                                />

                            </FormGroup>
                            <FormGroup>
                                <Label for="department">
                                    Passing Score
                                </Label>
                                <Input
                                    type="number"
                                    value={passingScore}
                                    min={0}
                                    max={9999}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setPassingScore(e.target.value)}
                                />

                            </FormGroup>
                        </div>
                        <Button color="primary" type={"submit"} disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm"/>
                            ) : (
                                "Save"
                            )}
                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default EditDifficulty;